// javascript-obfuscator go-chicken-go.min.js --output go-chicken-go.min.js
export class GameConstants {

    public static readonly VERSION = "1.011";
    public static readonly DEVELOPMENT = false;
    public static readonly SHOW_GUIDES = false;
    public static readonly SHOW_FPS = false;
    public static readonly SHOW_PHYSICS_BODIES = false;
    public static readonly VERBOSE = false;

    public static readonly GAME_WIDTH = 800;
    public static readonly GAME_HEIGHT = 450;  

    public static SPONSOR_NONE = "none";
    public static SPONSOR_MINIJUEGOS = "minijuegos";
    public static SPONSOR_LAGGED = "lagged";
    public static SPONSOR_GAMEPIND = "gamepind";
    public static SPONSOR_GAMEZOP = "gamezop";
    public static SPONSOR_GAMEPIX = "gamepix";
    public static SPONSOR_YANDEX = "Yandex";
    public static SPONSOR_FUNO = "funo";
    public static SPONSOR_GAME_DISTRIBUTION = "game distribution";
    public static SPONSOR = GameConstants.SPONSOR_GAME_DISTRIBUTION;

    public static readonly CAR_TYPE_1 = "car1";
    public static readonly CAR_TYPE_2 = "car2";
    public static readonly CAR_TYPE_3 = "car3";
    public static readonly CAR_TYPE_4 = "car4";
    public static readonly CAR_TYPE_5 = "car5";
    public static readonly CAR_TYPE_6 = "car6";
    public static readonly CAR_TYPE_7 = "car7";
    public static readonly CAR_TYPE_8 = "car8";
    public static readonly CAR_TYPE_9 = "car9";
    public static readonly CAR_TYPE_10 = "car10";

    public static readonly RIVER_LEFT = "river left";
    public static readonly RIVER_RIGHT = "river right";
    public static readonly RIVER_IN = "river in";

    public static readonly RIVER_LANE_0 = "river lane 0";
    public static readonly RIVER_LANE_1 = "river lane 1";

    public static readonly CAR = "car";
    public static readonly CHICKEN = "chicken";

    public static readonly CENTER = "center";
    public static readonly RIGHT = "right";
    public static readonly LEFT = "left";

    public static readonly BLOOD_COLOR = 0X9A0303;

    public static readonly BITMAP_SIZE = 64;

    public static readonly BLACK_SQUARE = "black-square";
    public static readonly WHITE_SQUARE = "white-square";
    public static readonly RED_SQUARE = "red-square";
    public static readonly ORANGE_SQUARE = "orange-square";
    public static readonly YELLOW_SQUARE = "yellow-square";
    public static readonly GREEN_SQUARE = "green-square";
    public static readonly GREY_SQUARE = "grey-square";
    public static readonly DARK_GREY_SQUARE = "dark-grey-square";

    public static readonly SAVED_GAME_DATA_KEY = "go-chicken-go-key";
    public static readonly LAGGED_ACHIEVEMENTS_DATA_KEY = "lagged-achievements-data-key";
}